import { gsap } from 'gsap'

export const globe = (target) => {
  var tl = gsap.timeline()
  tl.to(target,
    {
      fov: 1,
      duration: 3,
      ease: 'power2.inOut',
      onStart: () => {
        target.fovAnimating = true
      },
      onComplete: () => {
        target.fovAnimating = false
      }
    }
  )
  tl.to(
    target,
    {
      rotation: -4,
      duration: 3,
      ease: 'power2.inOut',
      onStart: () => {
        target.rotationAnimating = true
      },
      onComplete: () => {
        target.rotationAnimating = false
      }
    }, '<'
  )
  tl.to(
    target,
    {
      pan: 1,
      duration: 3,
      ease: 'power2.inOut',
      onStart: () => {
        target.panAnimating = true
      },
      onComplete: () => {
        target.panAnimating = false
      }
    }, '<'
  )
  return tl
}

export const setGlobe = (target) => {
  gsap.set(target, {
    fov: 0,
    rotation: 0,
    pan: 0,
    panAnimating: true,
    rotationAnimating: true,
    fovAnimating: true
  })
}
